import { useState } from "react";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { Icons } from "assets";
import { routeConstant } from "shared/routes/routeConstant";
import { ForgotPasswordVS } from "shared/utils/validation";
import { ForgotPasswordService } from "shared/services/auth";
import { toastMessage } from "shared/components/common/toast";
import { handleErrors } from "shared/utils/helper";
import classNames from "classnames";
import CustomButton from "shared/components/common/customButton";
import CustomInput from "shared/components/common/customInput";
import styles from "./style.module.scss";

const initialValues: ForgotPasswordType = {
  email: "",
};

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordVS,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      setSubmitting(true);
      try {
        const response = await ForgotPasswordService({
          email: values.email,
        });

        if (response.status === 200 || response.status === 201) {
          const message =
            response.data?.message ||
            response.data?.data?.message ||
            "Password reset instructions have been sent to your email";

          toastMessage("success", message);

          navigate(routeConstant.login.path);
        }
      } catch (error: any) {
        handleErrors(error);
      } finally {
        setLoading(false);
        setSubmitting(false);
      }
    },
  });

  const { handleChange, handleSubmit, values, touched, errors } = formik;

  return (
    <section
      className={classNames(
        "w-full flex flex-col items-center relative",
        styles.leftContainer,
      )}
    >
      <div className="flex items-center w-full justify-center m-auto">
        <form
          className={styles.formContainer}
          onSubmit={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleSubmit(e);
          }}
          noValidate
        >
          <div className="flex flex-col gap-3 text-center">
            <h1 className={classNames(styles.title, "text-center")}>
              Forgot Password
            </h1>
            <p className={classNames(styles.subTitle, "text-center")}>
              No worries, we’ll send you reset instructions.
            </p>
          </div>

          <div className="flex flex-col gap-2">
            <CustomInput
              label="Email Address"
              placeholder="e.g. abc@example.com"
              required
              Icon={Icons.Mail}
              type="email"
              value={values.email}
              error={touched.email && errors.email ? errors.email : ""}
              onChange={handleChange("email")}
              customLabelStyle={styles.labelStyle}
            />

            <div>
              <CustomButton
                title="Send Reset Link"
                titleStyle={classNames(styles.buttonTitle)}
                containerStyle="w-full bg-blue maxHeighted_btn"
                type="submit"
                loading={loading}
                disabled={loading}
              />
            </div>

            <div
              className={classNames(
                styles.link_container,
                "flex gap-2 items-center justify-center cursor-pointer mt-1",
              )}
              onClick={() => navigate(routeConstant.login.path)}
            >
              <Icons.ArrowLeftCircle />
              <p>Back To Login</p>
            </div>
          </div>
        </form>
      </div>
    </section>
  );
};

export default ForgotPassword;
